<template>
  <div>
    <vetster-slide-over-common-heading
      :header="$t('search.areas-of-interest')"
      :show-close="false"
      show-back
      is-simple-heading
      @back="$emit('previous', $event)"
    />
    <vetster-areas-of-interest
      class="px-standard -mt-1"
      :areas-of-interest="areasOfInterest"
      :limit="limit"
      stacked
    />
  </div>
</template>

<script>
import VetsterAreasOfInterest from '@/brand-components/VetsterAreasOfInterest';
import VetsterSlideOverCommonHeading from '@/brand-components/VetsterSlideOverCommonHeading';

export default {
  name: 'VetsterPartnerDetailsAreasOfInterest',

  components: {
    VetsterAreasOfInterest,
    VetsterSlideOverCommonHeading,
  },

  props: {
    areasOfInterest: {
      type: Array,
      default: () => [],
    },
    limit: {
      type: Number,
      default: 0,
    },
  },
};
</script>
